import {formatString} from '../utils/string'
import {Http} from './http';
import {ICaseTimeUrls} from './urls'
import {
    IGetAllCompanyCaseBaseData,
    IGetCurrentUserCaseViewData,
    IGetUserCaseViewData,
    IPutCaseOperationData,
    IPutCaseOperationParams
} from './caseTime.types'
import { requestConfigWrapper, PersistentCacheConfig, PersistentCacheStrategy } from '@patsnap/common-ps-http/dist/PersistentCache';

const persistCacheConfInst = new PersistentCacheConfig({
    strategy: PersistentCacheStrategy.CACHE_FIRST,
    async detectAllowCachingHook(resp): Promise<boolean> {
        if (!resp.ok) {
            return false
        }

        return resp.json().then(body => {
            return !!body;
        }).catch(() => false);
    },
});

export class CaseTimeService {
    constructor(
        private http: Http,
        private urls: ICaseTimeUrls) {
    }

    getEnableCaseView() {
        const url = this.urls.getCheckCaseUserAuthorizeV2
        return this.http.request<{ "authorized": boolean, "case_popup": boolean }>(requestConfigWrapper({
            method: 'get',
            url,
            uuid: url,
            cache: true,
        }, persistCacheConfInst))
    }

    getAllCompanyCaseBase() {
        const url = this.urls.getAllCompanyCaseBase
        return this.http.request<IGetAllCompanyCaseBaseData>({
            method: 'get',
            url,
        })
    }

    getUserCaseView(user_id: string) {
        const url = formatString(this.urls.getUserCaseView, {
            user_id
        })
        return this.http.request<IGetUserCaseViewData>({
            method: 'get',
            url,
        })
    }

    // 获取当前用户的caseView
    getCurrentUserCaseView() {
        const url = this.urls.getCurrentUserCaseView
        return this.http.request<IGetCurrentUserCaseViewData|''>({
            method: 'get',
            url,
        })
    }

    putCaseOperation(params: IPutCaseOperationParams) {
        const url = this.urls.putCaseOperation
        return this.http.request<IPutCaseOperationData>({
            method: 'put',
            url,
            data: {
                ...params,
            }
        })
    }

    heartBeat(userCaseId: string) {
        const url = this.urls.watchDog
        return this.http.request<number|string>({
            timeout: 10 * 1000,
            method: 'get',
            url,
            params: {
                user_case_id: userCaseId
            }
        })
    }
}
